<div class="center-container">

  <div *ngIf="busy">
    <p-progressSpinner [style]="{width: '30px', height: '30px'}" animationDuration=".5s"></p-progressSpinner>
  </div>

  <div *ngIf="!busy && !jobcard.jobCardID" class="error">
    {{'cyclist.problem_loading_quote_options' | translate}}
  </div>

  <div *ngIf="jobcard.jobCardID" style="padding-bottom: 32px;">
    <div class="label bold">{{jobcard.partnerName}} - #{{jobcard.jobCardID}}</div>
    <div class="label">{{jobcard.customer}}</div>
    <div class="label">{{jobcard.bike}}</div>
    <div class="label">{{jobcard.bookingDate | date : "medium"}}</div>
    <div class="label option-brief"
         *ngIf="jobcard.jobCardID && canRejectAll() && (jobcard.notes === '' || jobcard.notes === null)">{{'cyclist.multiquote_brief' | translate }}</div>
    <div class="label option-brief"
         *ngIf="jobcard.jobCardID && canRejectAll() && jobcard.notes !== null && jobcard.notes.length > 0"
         [innerHTML]="jobcard.notes">
    </div>
    <div class="options-container">
      <div *ngFor="let option of jobcard.quoteOptions" class="option-container content">
        <div class="option-name">{{option.optionName}}</div>
        <div class="option-description">{{option.optionDescription}}</div>

        <div class="partner-header quote-section-header margin-top-16" *ngIf="option.labourLineItems?.length > 0">
          <div>{{'bikeshop.workshop.jobcard.labour' | translate}}</div>
          <div>{{jobcard.currencySymbol}} {{option.labourAmount | number : '.2-2'}}</div>
        </div>
        <div *ngFor="let lineItem of option.labourLineItems" class="line-item">
          <div class="sku-name">
            <div>{{lineItem.name}}</div>
            <div class="breakdown">
              {{lineItem.quantity}} * {{jobcard.currencySymbol}}{{
              (jobcard.vatInclusive ?
                lineItem.unitPrice_IncludingTax : lineItem.unitPrice) | number : '.2-2'
              }}
              {{
              lineItem.discount > 0 ? ('(Total Discount ' + jobcard.currencySymbol + (lineItem.discount | number :
                '.2-2') + ')') : ''
              }}
            </div>
            <div class="note" *ngIf="lineItem.lineItemNote">{{lineItem.lineItemNote}}</div>
          </div>
          <div class="price">
            {{jobcard.currencySymbol}} {{
            (jobcard.vatInclusive ? lineItem.unitPrice_IncludingTax :
              lineItem.unitPrice) * lineItem.quantity | number : '.2-2'
            }}
          </div>
        </div>

        <div class="partner-header quote-section-header margin-top-16" *ngIf="option.partsLineItems?.length > 0">
          <div>{{'bikeshop.workshop.jobcard.parts_and_materials' | translate}}</div>
          <div>{{jobcard.currencySymbol}} {{option.partsAmount | number : '.2-2'}}</div>
        </div>
        <div *ngFor="let lineItem of option.partsLineItems" class="line-item">
          <div class="sku-name">
            <div>{{lineItem.name}}</div>
            <div class="breakdown">
              {{lineItem.quantity}} * {{jobcard.currencySymbol}}{{
              (jobcard.vatInclusive ?
                lineItem.unitPrice_IncludingTax : lineItem.unitPrice) | number : '.2-2'
              }}
              {{
              lineItem.discount > 0 ? ('(Total Discount ' + jobcard.currencySymbol + (lineItem.discount | number :
                '.2-2') + ')') : ''
              }}
            </div>
            <div class="note" *ngIf="lineItem.lineItemNote">{{lineItem.lineItemNote}}</div>
          </div>
          <div class="price">
            {{jobcard.currencySymbol}} {{
            (jobcard.vatInclusive ? lineItem.unitPrice_IncludingTax :
              lineItem.unitPrice) * lineItem.quantity | number : '.2-2'
            }}
          </div>
        </div>


        <div class="seperator"></div>
        <div class="totals">
          <div class="line-item">
            <!--<div class="total">{{jobcard.vatInclusive ? 'Subtotal (Excl VAT)' : 'Sub-Total'}}:</div>-->
            <!--          todo(dcorbett) *ngIf="vatInclusive" does not exist -->

            <div class="total">{{ "cyclist.subtotal" | translate }}:</div>
            <!--            <div class="total" *ngIf="!vatInclusive">{{ "cyclist.subtotal_excl" | translate }}:</div>-->
            <div class="price">{{jobcard.currencySymbol}} {{option.total_LineItems | number : '.2-2'}}</div>
          </div>
          <div class="line-item" *ngIf="helpersService.showTaxRow(option.total_Tax, jobcard)">
            <!--<div class="total">{{jobcard.vatInclusive ? 'VAT' : 'Tax'}}:</div>-->
            <div class="total">{{ "bikeshop.modal.update_job_card.quote.vat" | translate}}:</div>
            <!--            <div class="total" *ngIf="!vatInclusive">{{"bikeshop.modal.update_job_card.quote.vat" | translate}}:</div>-->
            <div class="price">{{jobcard.currencySymbol}} {{option.total_Tax | number : '.2-2'}}</div>
          </div>
          <div class="line-item" *ngIf="option.total_Discounts > 0">
            <!--<div class="total">{{jobcard.vatInclusive ? 'Discount (Incl VAT)' : 'Discount'}}:</div>-->
            <div class="total">{{ "cyclist.discount_incl" | translate}}:</div>
            <!--            <div class="total" *ngIf="!vatInclusive">{{"bikeshop.modal.update_job_card.quote.discount" | translate}}:</div>-->
            <div class="price">-{{jobcard.currencySymbol}} {{option.total_Discounts | number : '.2-2'}}</div>
          </div>
          <div class="seperator"></div>
          <div class="line-item">
            <div class="total">{{ "bikeshop.modal.update_job_card.quote.total" | translate}}:</div>
            <div class="price">{{jobcard.currencySymbol}} {{option.total_Price | number : '.2-2'}}</div>
          </div>
        </div>


        <div class="margin-top-8" *ngIf="option.approvalStatus < 9">
          <button pButton type="button" class="full-width p-mini green"
                  label="{{'cyclist.approve_this_option' | translate}}"
                  (click)="approveQuote(option)" [disabled]="busySubmitting || displayRejectAll"></button>
        </div>
        <div class="quote-approved" *ngIf="option.approvalStatus === 10">
          {{'cyclist.quote_approved' | translate}}
        </div>
        <div class="quote-rejected" *ngIf="option.approvalStatus === 9">
          {{'cyclist.quote_rejected' | translate}}
        </div>
      </div>
      <div class="reject-all-container" *ngIf="jobcard.jobCardID && canRejectAll()">
        <button pButton type="button" class="full-width p-mini" label="{{'cyclist.reject_all_quotes' | translate}}"
                (click)="displayRejectAll = true" [disabled]="busySubmitting || displayRejectAll"></button>
      </div>
    </div>
    <div *ngIf="canDoKlarnaPayment">
      <div class="klarna-container">
        <img src="https://hubtiger.blob.core.windows.net/partners/pay_with_klarna_black.png"/>
      </div>
      <div class="klarna-message">
        {{'cyclist.klarna_message' | translate }}
      </div>
    </div>
  </div>
</div>
<p-blockUI [blocked]="displayRejectAll">
  <div>
    <p-dialog [(visible)]="displayRejectAll">
      <p-header>
        {{'cyclist.reject_all_quotes' | translate}}
      </p-header>
      <div class="label">{{'cyclist.reject_quotes_reasons' | translate}}</div>
      <input type="text" pInputText [(ngModel)]="rejectionFeedback"/>
      <p-footer>
        <div class="row">
          <div class="col-6">
            <button pButton type="button" class="full-width alternate" label="{{'general.cancel' | translate}}"
                    (click)="displayRejectAll = false"></button>
          </div>
          <div class="col-6">
            <button pButton type="button" class="full-width" label="{{'cyclist.submit' | translate }}"
                    (click)="rejectAllOptions()"></button>
          </div>
        </div>
      </p-footer>
    </p-dialog>
  </div>
</p-blockUI>

<p-blockUI [blocked]="busySubmitting" *ngIf="busySubmitting">
  <div class="progress-spinner-container">
    <p-progressSpinner [style]="{ width: '60px', height: '60px' }" strokeWidth="4" fill="transparent"
                       animationDuration=".5s"></p-progressSpinner>
  </div>
</p-blockUI>
